import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SvgService } from '@/shared/services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'svg-icon-viewer',
  templateUrl: './svg-icon-viewer.component.html',
  styleUrl: './svg-icon-viewer.component.css',
  standalone: false,
})
export class SvgIconViewerComponent implements OnInit, OnDestroy {
  @Input() height: string = '90px';
  @Input() width?: string = '90px';
  @Input({ required: true }) svgFileName!: string;

  svgData!: SafeHtml;
  subscription!: Subscription;
  svgFillColorPrimary: string = environment['colors']['svg_icon_primary'];
  svgFillColorSecondary: string = environment['colors']['svg_icon_secondary'];
  svgFillColorSecondSecondary: string =
    environment['colors']['second_secondary'];
  svgFillColorAccent: string = environment['colors']['accent'];

  constructor(
    private svgService: SvgService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.loadSvg();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  loadSvg(): void {
    this.subscription = this.svgService
      .getSvg(`../../assets/svg-icons/${this.svgFileName}`)
      .subscribe((svg) => {
        svg = svg.replace(
          'svg-icon-fill-primary{fill:none',
          `svg-icon-fill-primary{fill:${this.svgFillColorPrimary}`,
        ); // Inject the fill primary color

        svg = svg.replace(
          'svg-icon-fill-secondary{fill:none',
          `svg-icon-fill-secondary{fill:${this.svgFillColorSecondary}`,
        ); // Inject the fill secondary color

        svg = svg.replace(
          'svg-icon-fill-second-secondary{fill:none',
          `svg-icon-fill-second-secondary{fill:${this.svgFillColorSecondSecondary}`,
        ); // Inject the fill secondary color

        svg = svg.replace(
          'svg-icon-fill-accent{fill:none',
          `svg-icon-fill-accent{fill:${this.svgFillColorAccent}`,
        ); // Inject the fill secondary color

        this.svgData = this.sanitizer.bypassSecurityTrustHtml(svg);
      });
  }
}
